import en from './en/common.json';
import is from './is/common.json';
import fr from './fr/common.json';
import de from './de/common.json';

export default {
  en: {
    common: en,
  },
  is: {
    common: is,
  },
  fr: {
    common: fr,
  },
  de: {
    common: de,
  },
};
